import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import Login from "@/views/Login";
import MainView from "@/views/MainView";
import AspectPage from "@/views/AspectPage";
import Dashboard from "../views/Dashboard.vue";
import EditUserPage from "@/views/EditUserPage";
import CreateUserPage from "@/views/CreateUserPage";
import Individuals from "@/views/IndividualsPage";
import EditAdminPage from "@/views/EditAdminPage";
import DiscoveryPage from "@/views/DiscoveryPage";
import FootprintPage from "@/views/FootprintPage";
import RetrogradePage from "@/views/RetrogradePage";
import FootprintPageSingle from "@/views/FootprintPageSingle";
import FootprintPageSingleAdd from "@/views/FootprintPageSingleAdd";
import DiscoveryPageSingle from "@/views/DiscoveryPageSingle";
import DiscoveryPageSingleAdd from "@/views/DiscoveryPageSingleAdd";
import AspectPageSingleAdd from "@/views/AspectPageSingleAdd";
import AspectPageSingle from "@/views/AspectPageSingle";

Vue.use(VueRouter);

let routes = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/",
    component: Dashboard,
    children: [
      {
        path: "/",
        name: "dashboard",
        component: MainView,
      },
      {
        path: "/individuals",
        name: "Individuals",
        component: Individuals,
      },
      {
        path: "/user/edit/:id",
        name: "User",
        exact: true,
        component: EditUserPage,
      },
      {
        path: "/admin-account",
        name: "Admin Account",
        exact: true,
        component: EditAdminPage,
      },
      {
        path: "/user/create",
        name: "Create User",
        exact: true,
        component: CreateUserPage,
      },
      {
        path: "/footprint",
        name: "Footprint List",
        exact: true,
        component: FootprintPage,
      },
      {
        path: "/footprint/add",
        name: "Add new Footprint",
        exact: true,
        component: FootprintPageSingleAdd,
      },
      {
        path: "/footprint/:id",
        name: "Single Footprint",
        exact: true,
        component: FootprintPageSingle,
      },
      {
        path: "/aspect",
        name: "Aspect",
        exact: true,
        component: AspectPage,
      },
      {
        path: "/aspect/add",
        name: "New Aspect",
        exact: true,
        component: AspectPageSingleAdd,
      },
      {
        path: "/aspect/:id",
        name: "Aspect Single",
        exact: true,
        component: AspectPageSingle,
      },
      {
        path: "/discovery",
        name: "Discovery",
        exact: true,
        component: DiscoveryPage,
      },
      {
        path: "/discovery/add-new-discovery",
        name: "New Discovery Interpretation",
        exact: true,
        component: DiscoveryPageSingleAdd,
      },
      {
        path: "/discovery/:id",
        name: "Discovery Single",
        exact: true,
        component: DiscoveryPageSingle,
      },
      {
        path: "/retrograde",
        name: "Retrogrades",
        exact: true,
        component: RetrogradePage,
      },
    ],
    beforeEnter: (to, from, next) => {
      if (store.state.isAuth) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: (to, from, next) => {
      if (store.state.isAuth) {
        next("/");
      } else {
        next();
      }
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: routes,
});

export default router;
